import { render } from "./BlogCategoryList.vue?vue&type=template&id=0cd2a96a"
import script from "./BlogCategoryList.vue?vue&type=script&lang=js"
export * from "./BlogCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__